import { IVirkeskopare, IVirkeskopfilter } from "./IVirkeskopFilter";

export class Virkeskopfilter implements IVirkeskopfilter {
    virkeskopareId: number;
    virkeskopare: IVirkeskopare[];
    kontraktsnummer: number;
    affarsformer: any[];
    prislista: string;

    constructor() {
        this.kontraktsnummer = undefined;
        this.virkeskopareId = undefined;
        this.virkeskopare = undefined;
        this.prislista = undefined;
    }
}
